import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { styled, SxProps, Theme } from "@mui/material/styles";
import React from "react";
import { useIsShowingLoader } from "./useIsShowingLoader";
interface LoaderProps {
  hideChildrenOnLoad?: boolean;
  loading: boolean;
  testId?: string;
  sx?: SxProps<Theme>;
}
interface FadeOpacityProps extends Pick<LoaderProps, "hideChildrenOnLoad"> {
  isLoading: boolean;
}

const LoadingContainerSC = styled("div")(
  () => `
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-grow: 1;
    `
);

const LoaderBoxSC = styled("div")(
  ({ hideChildrenOnLoad }: { hideChildrenOnLoad?: boolean }) => `
    position: ${hideChildrenOnLoad ? "fixed" : "absolute"};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: fit-content;
    height: fit-content;
  `
);

const FadeOpacitySC = styled("div")<FadeOpacityProps>`
  opacity: ${(props) => (props.isLoading ? (props.hideChildrenOnLoad ? 0 : 0.4) : 1)};
  height: 100%;
  width: 100%;
`;
const LoadingSpinner: React.FC<React.PropsWithChildren<LoaderProps>> = (props) => {
  const { loading, hideChildrenOnLoad, children, testId, sx } = props;
  const isLoading = useIsShowingLoader(loading);
  return (
    <LoadingContainerSC sx={sx}>
      {isLoading && (
        <LoaderBoxSC hideChildrenOnLoad={hideChildrenOnLoad} sx={sx}>
          <CircularProgress data-testid={testId} />
        </LoaderBoxSC>
      )}
      <FadeOpacitySC hideChildrenOnLoad={hideChildrenOnLoad} isLoading={isLoading}>
        <Box style={{ display: "flex", height: "100%", width: "100%" }}>
          <Box sx={{ position: "relative", display: "flex", height: "100%", width: "100%", flexDirection: "column" }}>
            {!(hideChildrenOnLoad && isLoading) && children}
          </Box>
        </Box>
      </FadeOpacitySC>
    </LoadingContainerSC>
  );
};

export default LoadingSpinner;
